import { render, staticRenderFns } from "./CustomerRecentInvoice.vue?vue&type=template&id=0977d54b&lang=pug&"
import script from "./CustomerRecentInvoice.vue?vue&type=script&lang=js&"
export * from "./CustomerRecentInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerRecentInvoice.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
